import { Navigate, Outlet } from "react-router-dom";
import { getStoredToken } from "../utils/impersonation.utils";

const DefaultLayout = () => {
  const token = getStoredToken();
  if (token) {
    return <Navigate to="/home" />;
  }
  return (
    <>
      <Outlet />
    </>
  );
};

export default DefaultLayout;
